export default "__VITE_ASSET__DkCfAwk1__"